import React, { useEffect, useState } from 'react';

import * as S from './styles';
import { useTab } from 'global/TabContext';
import { useUser } from 'global/UserContext';
import EducationShowcaseNextJS from 'microfrontends/Education/Showcase';

export const EducationShowcase = () => {
  const [activeTab] = useState('education_showcase');
  const { setActiveTabContext } = useTab();
  const { user } = useUser();
  const userId = user?.id;

  useEffect(() => {
    setActiveTabContext(activeTab);
  }, [activeTab, setActiveTabContext]);

  return (
    <S.Wrapper>
      <S.Content>{userId && <EducationShowcaseNextJS userId={userId} />}</S.Content>
    </S.Wrapper>
  );
};
